module.exports = __webpack_public_path__ + "static/20141025_132204-82c7fcad4a43f30b53cc67b4f404c1ce.jpg";